import { Link } from 'react-router-dom'
import { Compass } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { EmptyState } from '@/components/common/EmptyState'

export function NotFound() {
  return (
    <EmptyState
      icon={Compass}
      title="Página não encontrada"
      description="O endereço acessado não existe ou foi movido. Confira o link ou volte para o início."
      action={
        <Button asChild variant="outline">
          <Link to="/">Voltar para o início</Link>
        </Button>
      }
      className="py-24"
    />
  )
}
